import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd'
import { MdDragIndicator } from 'react-icons/md'

import { Box, HStack, Text } from '@chakra-ui/react'

import { DefaultFloorIndicator } from './DefaultFloorIndicator'
import { EditBadge } from './EditBadge'
import { FloorIcon } from './FloorIcon'

interface FloorListItemIProps {
  isEditEnabled: boolean
  hasIncidents: boolean
  isDefaultFloor: boolean
  isCurrentFloor?: boolean
  label: string
  onClick: () => void
  onEditButtonClick?: (event: React.MouseEvent) => void
  dragHandleProps?: DraggableProvidedDragHandleProps | null
}

export const FloorListItem = ({
  hasIncidents,
  isCurrentFloor,
  isDefaultFloor,
  isEditEnabled,
  label,
  onClick,
  onEditButtonClick,
  dragHandleProps,
}: FloorListItemIProps) => {
  return (
    <HStack
      _active={{
        backgroundColor: '#DCDFE4',
        boxShadow:
          '0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25)',
      }}
      _hover={{
        backgroundColor: isCurrentFloor ? '#E4E7EB' : '#F1F2F4',
        boxShadow:
          '0px 0px 1px rgba(9, 30, 66, 0.31), 0px 4px 8px rgba(9, 30, 66, 0.15)',
      }}
      backgroundColor={isCurrentFloor ? '#F1F2F4' : '#fff'}
      borderRadius='4px'
      boxShadow='0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25)'
      cursor='pointer'
      data-testid='floorPlanPage_floorsPanelItem'
      justifyContent='space-between'
      mb='10px'
      onClick={onClick}
      p='14px'
      role='group'
      transition='ease-in-out'
      transitionDuration='300ms'
      transitionProperty='all'
    >
      {dragHandleProps && (
        <Box
          {...dragHandleProps}
          alignItems='center'
          cursor='grab'
          display='flex'
          mr={2}
          onClick={(e) => e.stopPropagation()}
        >
          <MdDragIndicator size={18} />
        </Box>
      )}
      <FloorIcon hasIncidents={hasIncidents} />
      <Text
        color='#172B4D'
        fontSize='14px'
        fontWeight={500}
        isTruncated
        lineHeight='20px'
        w='full'
      >
        {label}
      </Text>
      {isEditEnabled && <EditBadge onClick={onEditButtonClick} />}
      {isDefaultFloor && <DefaultFloorIndicator />}
    </HStack>
  )
}
